







































































import Vue from 'vue'
import Component from 'vue-class-component'
import Multiselect from 'vue-multiselect'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
    Multiselect
  }
})
export default class MultiSelectWrapped extends Vue {
  tooltipText (values: any[]) {
    if (values.length && values.length > 1) {
      return values.map((item: any) => item.content).join(', ')
    }
    return null
  }

  clear () {
    this.$emit('input', '')
    this.$emit('close', '')
  }
}
